<div
  class="page-container"
  style="
  --home-banner-bg: url({{ 'assets/images/home/banner/banner-bg-v2.jpeg' | preferWebp }});
  --home-banner-bg-1: url({{ 'assets/images/home/banner/banner-bg-1.gif' }});

  --home-banner-app-bg: url({{ 'assets/images/home/banner/app-bg.jpg' | preferWebp }});

  --home-banner-app-bg-dark: url({{ 'assets/images/home/banner/app-bg-dark.jpg' | preferWebp }});
  "
>
  <div class="main-container">
    <!-- banner -->
    <div class="banner-container">
      <div class="page-max-width" (click)="jumpTo('promotions/offer#newuser')">
        <!-- 让内容置右空白50% -->
        <div class="half-space"></div>
        <!-- 登录之后显示存款红利 -->
        <div class="logined" *ngIf="logined">
          <div class="title">
            <p>{{ 'sports_betting' | translate }}</p>
          </div>
          <div class="sub-title">
            <p>{{ rebateTxt }}</p>
          </div>

          <div class="btns">
            <customize-button type="secondary-linear">
              {{ 'bet_now' | translate }}
            </customize-button>
          </div>
        </div>
        <!-- 未登录显示注册红利 -->
        <div class="nologin" *ngIf="!logined">
          <div class="title">
            <p>{{ 'sports_betting' | translate }}</p>
          </div>
          <div class="sub-title">
            <p>{{ rebateTxt }}</p>
          </div>

          <div class="btns">
            <a
              [href]="domain + '/' + appService.languageCode + '#' + 'register'"
              (click)="$event.preventDefault(); $event.stopPropagation()"
            >
              <customize-button type="secondary-linear" (onClick)="openRegisterDialog()">
                {{ 'register_now_button' | translate }}
              </customize-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- Live casino & Casino -->
      <div class="casino-container page-max-width">
        <!-- Casino -->
        <div class="casino">
          <div class="bg">
            <a
              class="bg-anchor-img"
              [href]="domain + '/' + appService.languageCode + '/promotions/offer#vipuser'"
              (click)="jumpTo('promotions/offer#vipuser'); $event.preventDefault()"
            >
              <img [src]="casinoBanner" />
            </a>
          </div>
        </div>
        <!-- Live casino -->
        <div class="live-casino">
          <div class="bg">
            <a
              class="bg-anchor-img"
              [href]="domain + '/' + appService.languageCode + '/promotions/offer#newuser'"
              (click)="jumpTo('promotions/offer#newuser'); $event.preventDefault()"
            >
              <img [src]="liveCasinoBanner" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 轮播图 -->
      <app-banner-manager class="carousel-container page-max-width" [buildFor]="CarouselType.Front" />

      <!-- 热门赛事 -->
      <app-popular-picks
        [style.display]="'block'"
        [style.marginTop.rem]="3"
        class="game-list-container page-max-width"
        [hideTitle]="!isH5"
        [titleContext]="'pop_eve' | translate"
        [tabTenantConfigDayKey]="'sportspopulareventsday'"
        [tabTenantConfigDarkKey]="'sportspopulareventsdark'"
        [matchRedirectPath]="'/play/SaBaSport-1/All'"
      />

      <!-- 热门游戏 -->
      <div class="game-list-container page-max-width">
        <app-new-swiper-unit
          [title]="labelList[0]?.labelName"
          [gameData]="labelList[0]?.gameLists"
          [assignUrl]="labelList[0]?.configUrl"
        ></app-new-swiper-unit>
      </div>

      <!-- 最新推荐 -->
      <div class="recod-container game-list-container page-max-width">
        <app-new-swiper-unit
          [title]="labelList[1]?.labelName"
          [gameData]="labelList[1]?.gameLists"
          [assignUrl]="labelList[1]?.configUrl"
        ></app-new-swiper-unit>
      </div>
      <!-- 供应商 -->
      <div class="provider-container page-max-width">
        <app-new-swiper-unit
          [title]="'game_pro' | translate"
          [providersData]="providers"
          [for]="'provider'"
        ></app-new-swiper-unit>
      </div>

      <!-- leader board -->
      <div class="leader-container page-max-width">
        <div class="tit">{{ 'home_race' | translate }}</div>
        <app-daily-races
          [gameCategories]="['SportsBook', 'Esports', 'Lottery', 'LiveCasino', 'SlotGame', 'Chess']"
        ></app-daily-races>
      </div>
    </div>
    <!-- 网站介绍、App下载 -->
    <div class="introduction-container">
      <div class="page-max-width">
        <div class="left">
          <div class="tit">
            {{ 'native_app' | translate }}
          </div>
          <div class="info1">
            {{ ('app_info' | translate).replace('16', periodYears) }}
          </div>
          <div class="info2">
            {{ 'app_leaders' | translate }}
          </div>
          <div class="btns">
            <customize-button type="primary-linear" minWidth="12rem" (onClick)="downloadApp()">
              {{ 'home_dl_ios' | translate }}
            </customize-button>
            <customize-button type="primary-linear" minWidth="12rem" (onClick)="downloadApp()">
              {{ 'home_dl_android' | translate }}
            </customize-button>
            <img
              src="assets/images/home/app_qr.svg"
              alt=""
              cdkOverlayOrigin
              #downloadOrigin="cdkOverlayOrigin"
              (mouseenter)="showPop()"
              (mouseleave)="closePop(150)"
              style="cursor: pointer"
            />
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="downloadOrigin"
              [cdkConnectedOverlayOpen]="downQR"
              [cdkConnectedOverlayPositions]="qrPopPositions"
              [cdkConnectedOverlayFlexibleDimensions]="true"
            >
              <div class="app-download-qr-pop" (mouseenter)="showPop(false)" (mouseleave)="closePop()">
                <a
                  [href]="appService.getAppUrl()"
                  rel="noopener"
                  target="_blank"
                  (click)="collectorService.sendAppInviteCode()"
                >
                  <qr-code [value]="appService.getAppUrl()" [margin]="3" [size]="152"></qr-code>
                </a>
              </div>
            </ng-template>
          </div>
        </div>
        <diV class="right">
          <img [src]="'assets/images/home/banner/app-main-kv.png' | preferWebp" />
        </diV>
      </div>
    </div>
  </div>
</div>
